import React, { Component } from 'react';
// import { Router, Route, Switch } from "react-router";
// import {courtspace} from '../images/courtspace.png'; 
// import { Grid, Row, Col } from 'react-flexbox-grid';
import './App.css';
import 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import { BrowserRouter as Router } from "react-router-dom";
import queryString from 'query-string'
import {FirebaseConfig} from './ApiKeys'
import * as firebase from 'firebase'
import 'firebase/firestore'
// import 'firebase/<PACKAGE>'

// initialize firebase 
if(!firebase.apps.length) {firebase.initializeApp(FirebaseConfig)}
// Initialize Cloud Firestore through Firebase
// const db = firebase.firestore();
// db.settings(settings)


class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      values:null
    }
  }

  _getStripeAuthCode=()=>{
    
  }



  componentDidMount() {
    const search = this.props.location.search
    // if (typeof(search) != "undefined") {
      const values = queryString.parse(search)
      // const parsed = queryString.parse(location.search);
      console.log('value',values);
    
    // const query = new URLSearchParams(this.props.location.search);
    // const token = query.get('token')
    // console.log(token)//123

      this.setState({
        values:values
      })
    // }
    
  } 





  render() {
    return (
      // <div class=" container card grey darken-4">
<Router>
    <div class="container ">
      
      <div class="col s12 ">
       <div >
       <h1> </h1>
       </div>
     </div>
     <div class="col s12 ">
       <div class="card grey darken-4">
         <div class="card-content white-text center-align">
                <h3  >courtspace </h3>
                <p class="center-align">connect with courtspace through Stripe</p>
         </div>
         <div class="card-action">
          
            <a href="https://connect.stripe.com/express/oauth/authorize?redirect_uri=https://courtspace-v2.firebaseapp.com/stripe/&client_id=ca_EGx2TdeM1vaqzhRIfN7c5au4Vfqzabhh">Go to stripe</a>
         </div>
       </div>
     </div>
     
   </div>
</Router>
        
   
     
      // </div>  
    )
  }
}

export default Home;


